// Shared formatting utilities — INR + Indian number formatting.

/** Format any number as ₹ with Indian grouping (₹1,00,000). */
export const inr = (n) => {
  if (n === null || n === undefined || n === "") return "—";
  const num = Number(n);
  if (!Number.isFinite(num)) return "—";
  return "\u20B9\u00A0" + formatIndianNumber(num);
};

/** Range like ₹5,000 – ₹10,000 */
export const inrRange = (min, max) => {
  if (min == null && max == null) return "—";
  if (min != null && max != null) return `${inr(min)} – ${inr(max)}`;
  return inr(min ?? max);
};

/** Indian grouping: last 3 digits, then groups of 2. */
export function formatIndianNumber(value) {
  if (value === null || value === undefined || value === "") return "";
  const digits = String(value).replace(/[^\d]/g, "");
  if (!digits) return "";
  const clean = digits.replace(/^0+(?=\d)/, "");
  if (clean.length <= 3) return clean;
  const last3 = clean.slice(-3);
  const rest = clean.slice(0, -3);
  const groups = rest.match(/(\d{1,2})(?=(?:\d{2})*$)/g);
  return `${(groups || []).join(",")},${last3}`;
}

/** Parse a formatted Indian number back to raw integer digits. Returns "" for empty. */
export function parseIndianNumber(formatted) {
  if (formatted === null || formatted === undefined) return "";
  return String(formatted).replace(/[^\d]/g, "");
}

/** Normalize a WhatsApp number to digits-only for wa.me URLs. */
export const normalizeWhatsapp = (n) => (n ? String(n).replace(/\D/g, "") : "");

/** Validate a URL loosely. Returns null if invalid, else normalized URL string. */
export const cleanUrl = (u) => {
  if (!u) return null;
  const t = String(u).trim();
  if (!t) return null;
  const withProto = /^https?:\/\//i.test(t) ? t : `https://${t}`;
  try { new URL(withProto); return withProto; } catch { return null; }
};

/** "Jaipur, Rajasthan" style. */
export const locationLine = (profile) =>
  profile?.location_label || [profile?.location_city, profile?.location_state].filter(Boolean).join(", ");
